/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import member from "../config/memberDetail.config.json";
import analytics from "../config/analyticsWidget.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { GET_COMMITTE_LIST, GET_PRESENTATIONS } from "../graphql";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICommitteListAnalyticsMethods extends IPluginMethodMap {
  getcommitteListAnalyticsProps(args: any): Promise<any>;
}

export class CommitteListAnalyticsService implements IAgentPlugin {
  readonly methods: ICommitteListAnalyticsMethods;

  constructor() {
    this.methods = {
      getcommitteListAnalyticsProps:
        this.getcommitteListAnalyticsProps.bind(this),
    };
  }

  async getcommitteListAnalyticsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("args==>", args?.criteria);
    const _filter = {};
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {},
          fetchPolicy: "network-only",
        });
        const activeItem = _res?.data?.getPresentations?.content.find(
          (item: any) => item.status === "active"
        );
        const defaultPresentation =
          activeItem && activeItem?.id
            ? activeItem?.id
            : _res?.data?.getPresentations?.content[0]?.id;
        let filter: any = args?.criteria?.partition
          ? {
            // userEmail: null,
            Invites___presentation: {
              eq:
                args?.criteria?.presentation ??
                args?.presentation ??
                defaultPresentation,
            },
            Invites___partition: {
              eq: args?.criteria?.partition,
            },
          }
          : {
            // userEmail: null,
            Invites___presentation: {
              eq:
                args?.criteria?.presentation ??
                args?.presentation ??
                defaultPresentation,
            },
          };
        // console.log();
        const res = await client.query({
          query: GET_COMMITTE_LIST,
          variables: {
            filter: filter,
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          let result = res?.data?.getAllCommitteInviteStatus?.content;
          console.log(res?.data?.getAllCommitteInviteStatus?.content);
          const rows = this.formatUserTable(result);
          const graphData = this.format(rows);
          const formattedGraphData = this.getTransformConfig(
            analytics,
            graphData
          );
          return {
            graph: formattedGraphData,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
    return { ...(analytics || {}) };
  }

  private formatUserTable(result: any) {
    let rows: any[] = [];
    result.forEach((item?: any) => {
      console.log(item);
      let user = {
        id: item?.id ?? "-",
        firstName: item?.firstName ?? "",
        surname: item?.lastName ?? "",
        fullName: item?.firstName
          ? item?.lastName
            ? item?.firstName + " " + item?.lastName
            : item?.lastName
          : item?.lastName
            ? item?.lastName
            : item?.email,
        email: item?.email ?? "",
      };
      let maxInvites = 0,
        purchased = 0,
        referalsUsed = 0,
        remaining = 0;
      item?.Invites.forEach((invite?: any) => {
        (maxInvites += invite?.maxInvites),
          (purchased += invite?.purchased),
          (referalsUsed += invite?.referalsUsed);
      });
      remaining = (maxInvites ?? 0) - (referalsUsed ?? 0);
      let userInvite = {
        maxInvites: maxInvites,
        purchased: purchased,
        inviteUsed: referalsUsed,
        remaining: remaining,
      };
      rows.push({
        ...user,
        ...userInvite,
      });
    });
    return rows;
  }
  private getTransformConfig(data: any, graphData: any) {
    let _data = data.layout[0].colProps[0].compProps.salesValue.day;
    _data.chartSeries[0].data = graphData[0]?.maxArray;
    _data.chartSeries[1].data = graphData[0]?.sentArray;
    _data.chartSeries[2].data = graphData[0]?.purchasedArray;
    _data.chartSeries[3].data = graphData[0]?.remainingArray;
    _data.chartSeries[0].name = `Max Invites (${graphData[0]?.maxCount})`;
    _data.chartSeries[1].name = `Invites Sent (${graphData[0]?.sentCount})`;
    _data.chartSeries[2].name = `Purchased (${graphData[0]?.purchasedCount})`;
    _data.chartSeries[3].name = `Remaining (${graphData[0]?.remainingCount})`;
    _data.labels = graphData[0]?.labArray;
    const formatted = JSON.stringify(data);
    return JSON.parse(formatted);
  }
  private format = (result: any[]): any[] => {
    let lab: any[] = [],
      label: any,
      max: number[] = [],
      sent: number[] = [],
      purchased: number[] = [],
      remaining: number[] = [],
      graphData: any[] = [];
    let maxCount = 0,
      sentCount = 0,
      purchasedCount = 0,
      remainingCount = 0;
    result.forEach((item) => {
      console.log("Hello", item);
      (maxCount += item?.maxInvites),
        (sentCount += item?.inviteUsed),
        (purchasedCount += item?.purchased),
        (remainingCount += item?.remaining),
        (label = item?.fullName
          ? item?.fullName.length > 32
            ? item?.fullName.slice(0, 30)
            : item?.fullName
          : item?.email
            ? item?.email.length > 32
              ? item?.email.slice(0, 30)
              : item?.email
            : "Null Null");
      lab.push(label ?? "Null Null");
      max.push(item?.maxInvites ?? 0);
      sent.push(item?.inviteUsed ?? 0);
      purchased.push(item?.purchased ?? 0);
      remaining.push(item?.remaining ?? 0);
    });
    graphData.push({
      labArray: lab,
      maxArray: max,
      sentArray: sent,
      purchasedArray: purchased,
      remainingArray: remaining,
      maxCount: maxCount,
      sentCount: sentCount,
      purchasedCount: purchasedCount,
      remainingCount: remainingCount,
    });
    return graphData;
  };

  private getMultiFilter(criteria: any) {
    const options = [
      {
        label: "Masquerader",
        value: "fe93dab0-424b-4aa3-9efa-c001b4c04444",
      },
      {
        label: "Admin",
        value: "fe93dab0-424b-4aa3-9efa-c001b4c03013",
      },
      {
        label: "committeeMember",
        value: "99403c8b-abc1-4796-b61f-78e0c4022792",
      },
      {
        label: "cashier",
        value: "f5bebfee-dc0a-460a-9a3f-c6cde8fed944",
      },
      {
        label: "supervisor",
        value: "ca9521c7-d584-43b8-8c90-79aa3e11bddc",
      },
      {
        label: "cashSupervisor",
        value: "5dbff659-66e4-4a66-b03c-f9b2d3dd6de6",
      },
    ];

    const transformedCriteria: any = [];
    Object.values(criteria).forEach((item: any) => {
      const column = item.filters.inputData.id;
      const op = item.filters.inputData.label;

      // Determine the value based on the available filter keys
      let value = "";
      if (column === "role" && "Equal" in item.filters) {
        const label = item.filters.Equal;
        const option = options.find((opt) => opt.label === label);
        if (option) {
          value = option.value.toLowerCase();
        }
      } else if ("Contains" in item.filters) {
        value = item.filters.Contains.toLowerCase();
      } else if ("Equal" in item.filters) {
        value = item.filters.Equal.toLowerCase();
      } // Add more conditions for other possible filter keys
      let changedOP = op === "Equal" ? "eq" : "contains";
      console.log(column);
      let changedCol;
      if (column == "email") {
        changedCol = "User___email";
      }
      if (column == "role") {
        changedCol = "User___role";
      }
      if (column == "fullName") {
        changedCol = "User___firstName";
      }
      transformedCriteria.push({
        changedCol,
        value,
        changedOP,
      });
    });

    return transformedCriteria;
  }
  private determineSearchType(criteria: any) {
    if (Object.keys(criteria)[0] === "0") {
      return "multi";
    } else {
      return "normal";
    }
  }
}
